export const getItem = (key: string) => {
  const item = JSON.parse(localStorage.getItem(key) || '{}')
  if (typeof item === 'undefined') {
    return null
  }
  return item
}
